// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nIkVK","delete":"styles_delete__1EeeC","update":"styles_update__2Xuzh","add":"styles_add__2XQSW"};